// @ts-nocheck
/* eslint-disable */
export const checklistRtlIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.33337 5.02323H1.33337V6.35656H7.33337V5.02323ZM7.33337 10.3566H1.33337V11.6899H7.33337V10.3566ZM10.8934 7.6899L8.53337 5.3299L9.47337 4.3899L10.8867 5.80323L13.7134 2.97656L14.6667 3.91656L10.8934 7.6899ZM10.8934 13.0232L8.53337 10.6632L9.47337 9.72323L10.8867 11.1366L13.7134 8.3099L14.6667 9.2499L10.8934 13.0232Z" fill="currentColor"/></svg>`,
    name: 'checklist-rtl' as const
};